<template>
    <div id="sentence-sets">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-edit"></i> Create your very own set of sentences</div>
            <p class="subtitle">Use any of the Magic Words below to further customize the sentences</p>
        </div>
        <!--<hr>-->
        <div class="columns">
            <div class="column">
                <div class="columns is-multiline box">
                    <div class="column is-6">
                        <div class="field">
                            <span class="heading has-text-grey-dark">Click <a href="https://www.youtube.com/watch?v=5O1LqV3E7cw&fbclid=IwAR0_eOa2g5Z2VnGG3kQZG109i-a93E2ebDZtWBovZoySIY7txrH69GqioD4" target="_blank">here</a> to watch a short tutorial</span>
                            <div class="control has-icons-left has-icons-right">
                                <textarea data-tour-sen-step="1"  id="sentence" class="is-primary textarea" name="sentence" v-model="sentence"  v-validate="'required'"  v-bind:class="{'input': true, 'is-danger': errors.has('sentence') }"
                                          type="text"
                                          placeholder="Type here to search our sentence database or create a new sentence"></textarea>
                                <transition name="fade-fast">
                                    <span v-show="errors.has('sentence')" class="help is-danger">{{ errors.first('sentence') }}</span>
                                </transition>
                                <span class="icon is-small is-left" >
                                        <i class="fa fa-search" v-if='!searching'></i>
                                        <i class="fas fa-spinner fa-spin" v-else></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <span class="heading has-text-grey-dark">Select category</span>
                        <div class="columns">
                            <div class="column"  data-tour-sen-step="5">
                                <div class="field">
                                    <div class="control">
                                        <div class="select is-info is-fullwidth">
                                            <select v-model="category">
                                                <option v-for="category in categories" v-bind:value="category.id">{{category.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column" v-if="selectedSentence == null"  data-tour-sen-step="6">
                                <div class="field">
                                    <div class="control">
                                        <loading-button v-bind:loading="addingSentence" icon="fa-plus" color="is-primary" @click="addSentence()">Add</loading-button>
                                    </div>
                                </div>
                            </div>
                            <div class="column" v-else>
                                <div class="field">
                                    <div class="control">
                                        <loading-button v-bind:loading="addingSentence" color="is-info" @click="updateSentence()">Update</loading-button>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <a class="button is-block is-danger" @click="cancelEditSentence()">Cancel</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12">
                        <magic-words :items="magicWords" @clickOnItem="addToSentence" data-tour-sen-step="2"/>
                    </div>

                    <div class="column is-12" v-if="filteredSentences.length > 0 || filteredMySentences.length > 0 || categoryFilters.length > 0" data-tour-sen-step="3">
                        <category-list :categories="categories" @click="toggleCategoryFilter"></category-list>
                    </div>
                </div>
                <clip-loader v-if="loadingSet"></clip-loader>
                <div class="columns is-multiline" v-if="!loadingSet">
                    <div class="column is-12-mobile" v-show="filteredSentences.length > 0 || sentence.length >=3">
                        <div class="columns box">
                            <div class="column is-12-mobile">
                                <p class="subtitle is-5">Search results:</p>
                                <span class="help is-info" v-if="filteredSentences.length > 0">Click on sentence or drag it to your set card!</span>
                                <div class="card clickable"  data-tour-sen-step="4" v-scroll-to="'#title'" id="step4" v-for='(sentence, index) in filteredSentences' v-draggable.filteredSentences="sentence" @click='selectSentence(sentence)'>
                                    <div class="card-content">
                                        <p class="subtitle">
                                        <div class="columns">
                                            <div class="column is-9 is-12-mobile content">
                                                <p class="has-text-grey-dark is-size-5 multiline-text" > {{sentence.text}} </p>
                                            </div>
                                            <div class="column is-3 is-12-mobile">
                                                <category-tag :key="category.id" v-for='category in sentence.categories' :category="category"></category-tag>
                                            </div>
                                        </div>
                                        </p>
                                    </div>
                                </div>
                                <clip-loader v-if="searching"></clip-loader>
                                <bulma-pagination style="margin-top:10px" :current="page" @change="onPageChanged" :last="total"></bulma-pagination>
                            </div>
                        </div>

                    </div>
                    <div class="column is-12-mobile">
                        <div class="columns box">
                            <div class="column box is-12-mobile scroll-y" v-droppable.filteredSentences="onSentenceDrop">
                                <p class="subtitle is-5" v-if="filteredMySentences.length > 0">Your set:</p>
                                <div class="notification is-danger has-text-centered" v-if="filteredMySentences.length == 0 && !loadingSet">
                                    <span>Ooops! No sentences found. Please add new sentences.</span>
                                </div>
                                <span class="help is-info" v-if="filteredMySentences.length > 0">Click on <i class="fa fa-trash has-text-danger"></i> in order to remove sentence</span>
                                <div class="card is-info" v-for='(sentence, index) in filteredMySentences'>
                                    <div class="card-content">
                                        <p class="subtitle">
                                        <div class="columns">
                                            <div class="column is-7 is-12-mobile content">
                                                <p class="has-text-grey-dark is-size-5 multiline-text" @click='selectSentence(sentence)' v-scroll-to="'#title'"> {{sentence.text}}</p>
                                        <!--<a class="delete is-hidden-tablet is-small is-pulled-right top" v-on:click="showDeleteModal(sentence.id, index)"></a>-->
                                            </div>
                                            <div class="column is-5 is-12-mobile">
                                                <a @click="showDeleteModal(sentence.id, index)" class="tooltip is-tooltip-top is-pulled-right" data-tooltip="Delete"><i class="fa fa-trash has-text-danger is-hidden-mobile"></i></a>
                                                <a v-scroll-to="'#title'" style="margin: 0px 10px" @click="editSentence(sentence, index)" class="tooltip is-tooltip-top is-pulled-right is-hidden-mobile has-text-warning" data-tooltip="Edit"><i class="fa fa-edit"></i></a>
                                                
                                                <category-tag :key="category.id" v-for='category in sentence.categories' :category="category" :right="true"></category-tag>
                                            </div>
                                            <div class="column is-2 is-12-mobile has-text-centered is-hidden-tablet">
                                                <a v-scroll-to="'#title'" @click="editSentence(sentence, index)" class="tooltip is-tooltip-top" data-tooltip="Edit"><i class="fa fa-edit has-text-warning"></i></a>
                                                <a @click="showDeleteModal(sentence.id, index)" class="tooltip is-tooltip-top" data-tooltip="Delete"><i class="fa fa-trash has-text-danger"></i></a>
                                            </div>
                                        </div>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<school-modal :schools="schools" :selectedSchools="selectedSchools" :showModal="schoolModal"></school-modal>-->
        <vue-tour :active="tourActive" :steps="tourSteps" btnDoneText="Next page" @onNextPage="nextPage" @onSkip="skipTour" @onStart="startTour"></vue-tour>
    </div>
</template>

<script>

    export default {
        name: 'sentence-sets',
        components: {},
        data() {
            return {
                searching: false,
                loadingSet: false,
                showQuickGuide: true,
                addingSentence: false,
                total: 1,
                page: 1,
                q: '',
                sentence: '',
                sentences: [],
                magicWords: [],
                filteredSentences:[],
                category: null,
                categories: [],
                categoryFilters: [],
                categoryForSearch: null,
                mySentences: [],
                filteredMySentences:[],
                selectedSentence: null,
                selectedIndex: -1,
                tourSteps: [
                    {
                        element: "[data-tour-sen-step='1']",
                        text: '<p class="has-text-justified">Use the <strong>search </strong> box to go-through <strong>all</strong> the sentences that were created by teachers from all over the world! Try typing any <strong>keyword</strong> or a part of a sentence and all matching sentences will be displayed below. Click on one of the matching sentences to add it to your <strong>collection</strong>. You can also write <strong>new sentences</strong> and combine them with <strong class="has-text-info"> "Magic Words"</strong> <br> <br>*<em>Popular keywords are: <strong>Learn</strong> ; <strong>Vocabulary</strong> ; <strong>Speaking</strong> ; <strong>Improving</strong> ;  </em> </p>'
                    },
                    {
                        element : "[data-tour-sen-step='2']",
                        text : '<p class="has-text-justified">These are <strong class="has-text-info"> "Magic Words"</strong>, they will <em>automatically </em> update to match the <strong>student</strong> and <strong>lesson</strong> info you input for that specific feedback. They are an amazing tool for creating <em>personalized</em> feedback! </p>',
/*                        options : {
                            btnBack : true,
                            nextPage : '/dashboard/comments',
                            nextPageText : 'Next page',
                        }*/
                    },
                    {
                        element: "[data-tour-sen-step='3']",
                        text: '<p class="has-text-justified"><em> Another</em> way to filter the search results is by <strong>categories </strong>. Try clicking on any <strong>category</strong> to display relevant results! </p>'
                    },
                    {
                        element: "[data-tour-sen-step='4']",
                        text: '<p class="has-text-justified">Let’s use this one as an <em>example </em>, please <strong>click</strong> on this <strong>sentence</strong> to select it   <br> <br><em>*These sentences were created by <strong>teachers </strong> from all over the world, however, you are <strong>free</strong> to modify them to match your personal style!</em> </p>'
                    },
                    {
                        element: "[data-tour-sen-step='5']",
                        text: '<p class="has-text-justified">Select the destination <strong>category</strong> for your <strong>sentence</strong> to be stored in. </p>'
                    },
                    {
                        element: "[data-tour-sen-step='6']",
                        text: '<p class="has-text-justified">Lastly, please <strong>click </strong> <strong class="has-text-primary"> +Add</strong> to finalize the process and add the sentences into desired <strong>category</strong>.    </p>'
                    },
                ],
            }
        },
        created(){
            this.loadPageData();
        },
        mounted(){

        },
        methods: {
            onPageChanged(page){
                this.page = page;
                this.sentences = [];
                this.filteredSentences = [];
                this.search();
            },
            loadPageData(){
                this.loadingSet = true;
                let self = this;
                this.pageRepo.getSentencesData(this.$route.path).then(response => {
                    let data = response.data.data;

                    this.categories = data.categories;
                    this.magicWords = data.magicWords;
                    this.category = this.categories[0].id;

                    this.prepareSentences(data.sentences);

                    if(data.tour.show) {
                        this.tourActive = true;
                    }

                });
            },

            prepareSentences(sentences){
                if(this.mySentences.length > 0){
                    this.mySentences = this.helper.updateSentenceColor(this.mySentences, this.categories);
                }

                this.loadingSet = false;
                if(sentences !== null){
                    this.mySentences = sentences;
                    if(this.categories.length > 0){
                        this.mySentences = this.helper.updateSentenceColor(this.mySentences, this.categories);
                    }
                }
                else{
                    this.mySentences = [];
                }

                //this.filteredMySentences = this.applyFilters(this.mySentences, this.filteredMySentences);

                this.filteredMySentences = this.mySentences;
            },

            addToSentence(text){
              this.sentence = this.sentence + text;
            },

            toggleCategoryFilter(categoryFilters){
                this.categoryFilters = categoryFilters;
                this.page = 1;
                if(categoryFilters.length >0){
                    this.categoryForSearch = categoryFilters[0].id;
                }else{
                    this.categoryForSearch = null;
                }
                this.search();
                //this.filteredSentences = this.applyFilters(this.sentences, this.filteredSentences);
                this.filteredMySentences = this.applyFilters(this.mySentences, this.filteredMySentences);
                
            },

            applyFilters(src, dest, direction = 'asc'){

                if(src == null || src == 0){
                    return [];
                }
                let self = this;
                if(this.categoryFilters == null || this.categoryFilters.length > 0){
                    dest = _.filter(src, function(sentence) {
                        if(!sentence.categories || sentence.categories.length == 0){
                            return false;
                        }

                        return _.indexOf(_.map(self.categoryFilters, 'name'), sentence.categories[0].name) != -1;
                    });
                }
                else{
                    dest = JSON.parse(JSON.stringify(src));
                }

                if(this.sentence != ''){
                    dest = dest.filter(sentence => {
                        return sentence.text.toLowerCase().includes(this.sentence.toLowerCase())
                    })
                }


                dest = _.orderBy(dest, function(e) {
                    if(e.categories != null && e.categories.length > 0){
                        return e.categories[0].id;
                    }
                    return e.id;
                }, [direction]);
                return dest;
            },

            selectSentence(sentence){
                this.sentence = sentence.text;

                this.category = sentence.categories[0].id;
            },

            onSentenceDrop ($ev) {
                $ev = JSON.parse($ev);
                let sentence = {
                    text: $ev.text,
                    category: $ev.categories[0].id
                };

                this.addSentence(sentence);
            },

            addSentence(sentence){
                if(sentence === undefined){
                    sentence = {
                        text: this.sentence,
                        category: this.category,
                    }
                }

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        var self = this;
                        this.loadingSet = true;
                        this.addingSentence = true;
                        this.sentenceRepo.store(sentence).then(response => {
                            var message = response.data.message;
                                self.loadingSet = false;
                                self.addingSentence = false;
                                self.$toast.success(message);
                                self.mySentences = self.mySentences.concat(this.helper.updateSentenceColor([response.data.data], this.categories));
                                this.filteredMySentences = this.applyFilters(this.mySentences, this.filteredMySentences);
                        }).catch((response) =>{
                            self.loadingSet = false;
                            self.addingSentence = false;
                            return Promise.reject(response);
                        });
                    }
                });
            },

            editSentence(sentence, index){
                this.sentence = sentence.text;
                this.category = sentence.categories[0].id;
                this.selectedSentence = sentence;
                this.selectedIndex = index;
            },

            cancelEditSentence(){
                this.sentence = "";
                this.category = 1;
                this.selectedSentence = null;
                this.selectedIndex = -1;
            },

            updateSentence(){
                let self = this;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        self.loadingSet = true;
                        self.addingSentence = true;
                        let sentence = self.selectedSentence;
                        sentence.text = self.sentence;
                        sentence.category = self.category;
                        let id = self.selectedSentence.id;
                        self.sentenceRepo.update(id, sentence).then(response => {
                            var message = response.data.message;

                            self.loadingSet = false;
                            self.addingSentence = false;
                            self.$toast.success(message);

                        }).finally(()=>{
                            self.category = 1;
                            self.selectedSentence = null;
                            self.selectedIndex = -1;
                            self.loadingSet = false;
                            self.addingSentence = false;
                        });

                        self.sentenceRepo.get(id).then(response => {

                            for(var i = 0; i < self.mySentences.length; i++){
                                if(self.mySentences[i].id == id){
                                    self.mySentences[i].text = response.data.data.text;
                                    self.mySentences[i].categories = response.data.data.categories;
                                    self.mySentences = this.helper.updateSentenceColor(self.mySentences, self.categories);
                                    self.filteredMySentences = self.applyFilters(self.mySentences, self.filteredMySentences);
                                }
                            }
                        });
                    }
                });
            },

            showDeleteModal(id, index){
                let self = this;
                this.$swal({
                    title: 'Are you sure?',
                    text: "The sentence will be permanently deleted from all your templates!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3273dc',
                    cancelButtonColor: '#ff3860',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result && result.value) {
                        self.deleteSentence(id, index);
                    }
                }).catch((result) => {
                });

            },

            deleteSentence (id, index) {
                this.sentenceRepo.delete(id).then(response => {
                    this.mySentences = this.mySentences.filter(item => item.id !== id);
                    this.filteredMySentences = this.filteredMySentences.filter(item => item.id !== id);
                    this.$swal(
                        'Deleted!',
                        'The sentence has been deleted.',
                        'success'
                    )
                });
            },

            search(){
                this.searching = true;
                let data ={page: this.page, query: this.sentence, category:this.categoryForSearch};
                //console.log(data);
                this.sentenceRepo.search(data).then(response => {
                    this.searching = false;
                    if(response.data.data !== null){
                        this.sentences = response.data.data;
                    }
                    else{
                        this.sentences = [];
                    }
                    this.sentences = this.helper.updateSentenceColor(this.sentences, this.categories);
                    this.filteredSentences = this.applyFilters(this.sentences, this.filteredSentences, "asc");
                    this.total = response.data.meta.pagination.total_pages
                }).catch((response) =>{
                    this.searching = false;
                    return Promise.reject(response);
                });
            },

        },
        watch: {
            sentence: _.debounce(function(value){
                if(value.length >= 3){
                    this.search();
                    this.filteredMySentences = this.applyFilters(this.mySentences, this.filteredMySentences);
                }

                if(value == ''){
                    this.sentences = [];
                    this.filteredMySentences = this.applyFilters(this.mySentences, this.filteredMySentences);
                }
            }, 800)

        }

    }
</script>

<style lang="css" scoped>

    .card-content{
        padding-top:2px;
        padding-bottom:2px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/SentenceSets.vue